/* eslint react/style-prop-object: 0 */
import React from 'react';
import { Empty } from 'antd';
import ResponsivePie from 'Common/Components/LazyResponsivePie';
import { FormattedMessage, useIntl } from 'react-intl';
import withLoading from 'Common/HOC/loadingOr';

interface PieData {
  color: string;
  id: number | string;
  value: number;
  label: string;
}

interface Props {
  currency: string;
  data?: PieData[];
}

const NoData = () => (
  <Empty
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    description={<FormattedMessage defaultMessage="No data" />}
  />
);

const RevenueOverviewRevenueByPaymentChart: React.FC<Props> = ({
  currency,
  data = [],
}) => {
  const intl = useIntl();
  if (data.length === 0) {
    return <NoData />;
  }
  return (
    <ResponsivePie
      data={data.map((d) => ({
        ...d,
        label: `${d.label}: ${intl.formatNumber(d.value, {
          style: 'currency',
          currency,
        })}`,
      }))}
      innerRadius={0.6}
      enableArcLinkLabels={false}
      enableArcLabels={false}
      valueFormat={(v) => intl.formatNumber(v, { style: 'currency', currency })}
      colors={(v) => (v.data as PieData).color}
      legends={[
        {
          anchor: 'bottom-right',
          direction: 'column',
          translateY: -10,
          itemWidth: 100,
          itemHeight: 25,
          itemTextColor: '#000',
          itemDirection: 'right-to-left',
          symbolSize: 18,
          symbolShape: 'circle',
        },
      ]}
      tooltip={({ datum: { label } }) => {
        const parts = label.toString().split(':');
        return (
          <span>
            <strong>{parts[0]}:</strong>
            {parts[1]}
          </span>
        );
      }}
    />
  );
};

export default withLoading(RevenueOverviewRevenueByPaymentChart);
